import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_CONFIRM_MOLLIE_BATCH,
    FAILURE_MOLLIE_BATCHES,
    FAILURE_MOLLIE_SETTLEMENT_ORDERS,
    FETCH_MOLLIE_BATCHES,
    REQUEST_CONFIRM_MOLLIE_BATCH,
    REQUEST_MOLLIE_BATCHES,
    REQUEST_MOLLIE_SETTLEMENT_ORDERS,
    SUCCESS_CONFIRM_MOLLIE_BATCH,
    SUCCESS_MOLLIE_BATCHES,
    SUCCESS_MOLLIE_SETTLEMENT_ORDERS,
} from './actions';

export function mollieBatchReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case FETCH_MOLLIE_BATCHES:
            return _.assign({}, state, {
                lastFilter: {
                    pageable: action.pageable,
                    settlementId: action.settlementId,
                    confirmedState: action.confirmedState,
                },
            });
        case REQUEST_MOLLIE_BATCHES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_MOLLIE_BATCHES:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        case FAILURE_MOLLIE_BATCHES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function mollieSettlementOrdersReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_MOLLIE_SETTLEMENT_ORDERS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_MOLLIE_SETTLEMENT_ORDERS:
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data?.orders ?? [],
                error: undefined,
            });
        case FAILURE_MOLLIE_SETTLEMENT_ORDERS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function mollieBatchConfirmReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CONFIRM_MOLLIE_BATCH:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CONFIRM_MOLLIE_BATCH:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_CONFIRM_MOLLIE_BATCH:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
